/**
 * Folds the spellings people mix up when typing Arabic, so "أكتيف", "اكتيف"
 * and "إكتيف" all match, as do "كريمة"/"كريمه" and "واقي"/"واقى". Also drops
 * the short vowel marks and the stretching dash, and lowercases Latin letters.
 *
 * Keep in step with `normalizeArabic` in the backend's
 * `src/search/helpers/halazon.ts`: the index stores text folded the same way.
 */
export function normalizeArabic(value: string | null | undefined): string {
  return (value ?? "")
    .replace(/[\u064B-\u065F\u0670\u0640]/g, "")
    .replace(/[أإآٱ]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ة/g, "ه")
    .replace(/ؤ/g, "و")
    .replace(/ئ/g, "ي")
    .toLowerCase()
    // Punctuation never blocks a match: "Dr.Clinic" is found by "dr clinic".
    .replace(/[.,،؛:;!?؟'"`()\[\]{}\/\\|+*%&#@^~=<>_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
}
